import React, { useState } from 'react';
import { useAppContext } from '../../contexts/AppContext';
import styles from './SyncButton.module.scss';

const SyncButton = () => {
  const { syncAuditDataToNotifications, auditItems, showAlert } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);

  const handleSync = async () => {
    setIsLoading(true);
    try {
      await syncAuditDataToNotifications(auditItems);
      await showAlert('success', '同步成功', '审核数据已同步到通知中心！');
    } catch (error) {
      console.error('同步失败:', error);
      await showAlert('error', '同步失败', '同步失败，请重试');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button 
      className={styles.syncButton}
      onClick={handleSync}
      disabled={isLoading}
    >
      {isLoading ? '同步中...' : '同步审核数据'}
    </button>
  );
};

export default SyncButton;
